import React from 'react'
import styles from './GameTopRow.module.css';
// import GameMenu from '../GameMenu/GameMenu';
import {GameMenu} from '@themed-components';
import ActiveGamesRow from '../ActiveGamesRow/ActiveGamesRow';
import { useIsTourneyGame } from '@/src/hooks/data/useGameTable';
import TourneyNextUp from '../TourneyNextUp/TourneyNextUp';
import TourneyRankingLeaderboard from '../TourneyRankingLeaderboard/TourneyRankingLeaderboard';

export default function GameTopRow({ setActiveDrawer, activeGames, activeGame }) {
    const isTourneyGame = useIsTourneyGame(activeGame);

    return (
        <div className={styles.gameTablesContainerTopRowContainer}>
            <div className={styles.gameTablesContainerTopRow}>
                <div className={styles.gameTablesContainerRowLeft}>
                    {/* Button To Open Consolidated Menu */}
                    <GameMenu setActiveDrawer={setActiveDrawer} tempTableId={activeGame} />
                    {/* Row of Active Games */}
                    <ActiveGamesRow activeGames={activeGames} activeGame={activeGame} />
                </div>
                <div className={styles.gameTablesContainerRowRight}>
                    {/* {
                        isTourneyGame && (
                            <TourneyRankingLeaderboard tempTableId={activeGame} />
                        )
                    } */}
                </div>
            </div>
            <div className={styles.gameTablesContainerBottomRow}>
                <div className={styles.gameTablesContainerRowLeft}>
                    {
                        isTourneyGame && (
                            <TourneyNextUp activeGame={activeGame} />
                        )
                    }
                </div>
                <div className={styles.gameTablesContainerRowRight}>
                    {
                        isTourneyGame && (
                            <TourneyRankingLeaderboard tempTableId={activeGame} />
                        )
                    }
                </div>
            </div>
        </div>
    )
}
